import BooleanTag from '@/components/app/BooleanTag';
import CreateBtn from '@/components/app/CreateBtn';
import ZTable, { IColumnType, IFilterItem, ITableRef } from '@/components/ZTable';
import { PaymentModeType, PaymentTermsType, PlanType } from '@/constants';
import MainContent from '@/layouts/MainContent';
import { Tag, Tooltip } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CreateUpdateModal from './CreateUpdateModal';
import { PlanModel } from '@/__generated';

const PAGE_TITLE = 'planPage_Title';

const filters: Array<IFilterItem> = [{ type: 'TEXT', name: 'searchText', mdSize: 8, xlSize: 8, xxlSize: 8, label: 'planPage_SearchText' }];

const columns: IColumnType<PlanModel>[] = [
  {
    title: 'planPage_PlanName',
    dataIndex: 'planName',
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: 'planPage_NoOfRegister',
    dataIndex: 'noOfRegister',
    ellipsis: true,
  },
  {
    title: 'planPage_TransactionLimit',
    dataIndex: 'transactionLimit',
    ellipsis: true,
  },
  {
    title: 'planPage_Turnover',
    dataIndex: 'turnover',
    ellipsis: true,
  },
  {
    title: 'planPage_MonthlyFee',
    dataIndex: 'monthlyFee',
    ellipsis: true,
  },
  {
    title: 'planPage_PaymentTerm',
    dataIndex: 'paymentTermType',
    ellipsis: true,
    render: v => <Tag>{PaymentTermsType.__getValue(v)}</Tag>,
  },
  {
    title: 'planPage_PaymentMethodType',
    dataIndex: 'paymentMethodType',
    ellipsis: true,
    render: v => <Tag>{PaymentModeType.__getValue(v)}</Tag>,
  },
  {
    title: 'planPage_PlanType',
    dataIndex: 'planType',
    ellipsis: true,
    render: v => <Tag>{PlanType.__getValue(v)}</Tag>,
  },
  {
    title: 'planPage_IsPopular',
    dataIndex: 'isPopular',
    render: v => <BooleanTag value={v} />,
    align: 'center',
    ellipsis: true,
  },
  {
    title: 'base.Description',
    dataIndex: 'description',
    width: 150,
    ellipsis: true,
    render: v => (v ? <Tooltip title={v}>{v}</Tooltip> : ''),
  },
];
export default function PlansPage() {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [formVisible, setFormVisible] = React.useState(false);
  const [planId, setPlanId] = React.useState<string>();

  const onEdit = (id: string) => {
    setPlanId(id);
    setFormVisible(true);
  };
  return (
    <MainContent
      title={t(PAGE_TITLE)}
      extraBtns={[
        <CreateBtn
          onClick={() => {
            setFormVisible(true);
          }}
        />,
      ]}
    >
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <ZTable
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/commons/plans/get-plans"
          bordered
          order_by="planName"
          order_by_asc={true}
          allowEdit={true}
          allowDelete={true}
          onEdit={record => {
            onEdit(record.id);
          }}
          delete_url="/commons/plans/delete"
          filters={filters}
          searchBtnAlignLeft
        />
      </div>
      {formVisible ? (
        <CreateUpdateModal
          planId={planId}
          onClose={reload => {
            setFormVisible(false);
            setPlanId(undefined);
            if (reload) {
              zTb.current?.reload();
            }
          }}
        />
      ) : null}
    </MainContent>
  );
}
